import request from '@utils/request'

export function fetchList(params) {
  return request({
    url: '/admin/lang',
    method: 'get',
    params,
  })
}

export function fetchLangsByName(name) {
  return request({
    url: `/admin/lang/${name}`,
    method: 'get',
  })
}

export function createLang(data) {
  return request.post('/admin/lang', data)
}

export function updateLang(data) {
  return request.put(`/admin/lang/${data.seq}`, data)
}

export function deleteLang(seq) {
  return request.delete(`/admin/lang/${seq}`)
}
